// extracted by mini-css-extract-plugin
module.exports = {"Container":"Card_Container__o0NyY","Primary":"Card_Primary__2FrHr","Secondary":"Card_Secondary__WxZXL","Danger":"Card_Danger__1tv9r"};